<template>
	<header class="header">


		<SignedInHeaderUserInfo v-if="isAuthenticated" style="pointer-events: auto;"/>
		<SignedOutHeader v-else />


	</header>
</template>



<script>

import { computed } from "vue";
import { useAuthStore } from "@/store/AuthStore";
import SignedOutHeader from "../Header/Signed-Out-Header.vue";
import SignedInHeaderUserInfo from "../Header/Signed-In-Header-User-Info.vue";

export default {
	name: "Header-Component",
	components: {
		SignedOutHeader,
		SignedInHeaderUserInfo,
	},
	setup() {
		const authStore = useAuthStore();
		const isAuthenticated = computed(() => authStore.isUserLoggedIn());

		return { isAuthenticated };
	},
};

</script>